var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2063",
    "data-name": "Group 2063",
    transform: "translate(-370 -1168)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_512",
    "data-name": "Ellipse 512",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(370 1168)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42828",
    "data-name": "Path 42828",
    d: "M-3170.945,1439.537l5.463,5.463,5.463-5.463",
    transform: "translate(-2780.519 2625.5) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownarrow);
export default __webpack_public_path__ + "static/media/dropdownarrow.3c80f6eef22b0b66414d182c059c8e31.svg";
export { ForwardRef as ReactComponent };